/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/


import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import React from 'react';

export interface IItemAddedToCartDialogProps {
    className: string;
    alternateItem: boolean;
    isSoftSupresede: boolean;
    isBackOrdered: boolean;
    modalHeader: string;
    modalBodyText: string;
    modalOpen: boolean | undefined;
    quantity: number;
    isLimitedBackOrdered: boolean;
    onClose(): void;
    onClosePopup(): void;
    _addItemToCartCustom(quantity: number): void;
    onSoftSupresedeYesClick(quantity: number): void;
    onSoftSupresedeNoClick(quantity: number): void;
}

export const ConfirmAddedToCartDialog = (dialogProps: IItemAddedToCartDialogProps) => {
    const {

        className,

        modalOpen

    } = dialogProps;


    const close: () => void = () => {
        dialogProps.onClose();
    };

    const _addItemToCartCustom: () => void = () => {
        dialogProps._addItemToCartCustom(dialogProps.quantity);
    };

    const closePopup: () => void = () => {
        dialogProps.onClosePopup();
    };

    const onSoftSupresedeYesClick: () => void = () => {
        dialogProps.onSoftSupresedeYesClick(dialogProps.quantity);
    };

    const onSoftSupresedeNoClick: () => void = () => {
        dialogProps.onSoftSupresedeNoClick(dialogProps.quantity);
    };

    return (
        <Modal isOpen={modalOpen} className={`${className}`} toggle={!dialogProps.alternateItem ?   close : closePopup}>
            <ModalHeader className={`${className}__dialog__header`} toggle={!dialogProps.alternateItem ?  close : closePopup}>
                <span>{dialogProps.modalHeader}</span>
            </ModalHeader>
            <ModalBody className={`${className}__dialog__body`}>
                <div className={`${className}__dialog__content`} style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{ __html: dialogProps.modalBodyText }}
                />
            </ModalBody>
            <ModalFooter
                className={`${className}__dialog__footer`}
            >
                {!dialogProps.alternateItem ? dialogProps.isSoftSupresede ? ((<div><Button //&& (dialogProps.isBackOrdered || dialogProps.isLimitedBackOrdered) ? ((<div><Button
                    className={`${className}__dialog__view-cart-button`}
                    title={`Continue`} onClick={onSoftSupresedeYesClick}

                >
                    Continue
                </Button>
                    {/* <Button
                        className={`${className}__dialog__view-cart-button`}
                        title={`BackOrder`} onClick={_addItemToCartCustom}

                    >
                        BackOrder
                    </Button> */}
                    <Button
                        className={`${className}__dialog__continue-shopping`}
                        title={'Cancel'}
                        onClick={close}
                    >
                        {'Cancel'}
                    </Button>
                </div>)) : dialogProps.isSoftSupresede ? ((<div><Button
                    className={`${className}__dialog__view-cart-button`}
                    title={`Yes`} onClick={onSoftSupresedeYesClick}

                >
                    Yes
                </Button>
                    <Button
                        className={`${className}__dialog__continue-shopping`}
                        title={'No'}
                        onClick={onSoftSupresedeNoClick}
                    >
                        {'No'}
                    </Button>
                </div>)) : (<div><Button
                    className={`${className}__dialog__view-cart-button`}
                    title={`Yes`} onClick={_addItemToCartCustom}

                >
                    Yes
                </Button>
                    <Button
                        className={`${className}__dialog__continue-shopping`}
                        title={'No'}
                        onClick={close}
                    >
                        {'No'}
                    </Button>
                </div>) : (<Button
                    className={`${className}__dialog__continue-shopping`}
                    title={'Close'}
                    onClick={closePopup}
                >
                    Close
                </Button>)}

            </ModalFooter>
        </Modal>
    );
};
